import { render } from "./TronTransactions.vue?vue&type=template&id=5802c0b2"
import script from "./TronTransactions.vue?vue&type=script&lang=js"
export * from "./TronTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__